/*
 * dän v3.9 mixed-bag rule: a bag holding any catering product (bulk dozens, platters, boxes — product type
 * "Catering") checks out as a CATERING PICKUP, never as a café pickup.
 *
 * Why: BakeOps (apps/api/src/modules/shopify/rules.ts ruleKind) treats an order with a catering-tagged line as
 * catering and needs "Catering date"; the cart drawer (assets/dan-cart.js) writes café-pickup attributes and
 * clears the catering ones, so such an order would be held. This rewrites the drawer's checkout attributes into
 * the shape the catering page sends (snippets/dan-catering-store.liquid): Order type Catering, Catering method
 * Pickup, Catering store, Catering date, Catering time. The day and time the customer chose in the bag are kept.
 * A bag with no catering product is untouched. The pickup location the drawer sets at checkout is unchanged.
 */
(function () {
  var orig = window.fetch;
  if (!orig || orig.__d9) return;
  function isUpdate(url) { try { return /\/cart\/update(\.js)?$/.test(new URL(String(url), location.href).pathname); } catch (e) { return false; } }
  var wrapped = function (url, opts) {
    var body;
    try { body = opts && opts.method === 'POST' && typeof opts.body === 'string' ? JSON.parse(opts.body) : null; } catch (e) { body = null; }
    var a = body && body.attributes;
    if (!isUpdate(url) || !a || a['Order type'] !== 'Pickup' || !a['Pickup date']) return orig.apply(this, arguments);
    var self = this, args = arguments;
    return orig('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var catering = (cart.items || []).some(function (i) { return /catering/i.test(i.product_type || ''); });
      if (!catering) return orig.apply(self, args);
      var time = String(a['Pickup time'] || '').split('·').pop().trim();
      a['Order type'] = 'Catering';
      a['Catering method'] = 'Pickup';
      a['Catering store'] = a['Pickup store'] || '';
      a['Catering date'] = a['Pickup date'];
      a['Catering time'] = time;
      a['Pickup date'] = '';
      a['Pickup time'] = '';
      var o = {}; for (var key in opts) o[key] = opts[key];
      o.body = JSON.stringify(body);
      return orig.call(self, url, o);
    }, function () { return orig.apply(self, args); });
  };
  wrapped.__d9 = true;
  window.fetch = wrapped;
})();
